import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=d4c2f2a4&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4c2f2a4')) {
      api.createRecord('d4c2f2a4', component.options)
    } else {
      api.reload('d4c2f2a4', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=d4c2f2a4&", function () {
      api.rerender('d4c2f2a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wo5Q3uq8zrpG/JS/comp/ImgFallback.vue"
export default component.exports